import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  updateProfile,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCcX8N9o1WkMvpgV_xEYZwI76Pd9hgWv7o",
  authDomain: "dadabro-dc6b8.firebaseapp.com",
  projectId: "dadabro-dc6b8",
  storageBucket: "dadabro-dc6b8.firebasestorage.app",
  messagingSenderId: "750068523201",
  appId: "1:750068523201:web:a9bcb195fc3bec24f27440",
  measurementId: "G-6MPHCETMFC",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// 이메일 회원가입 함수
const registerWithEmail = async (email, password, displayName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    await updateProfile(userCredential.user, { displayName });
    return userCredential.user;
  } catch (error) {
    console.error("회원가입 오류:", error);
    return null;
  }
};

export { db, auth, registerWithEmail, storage };
